export default {
    getMonthYear(date, month, setMonth) {
        date.setMonth(setMonth);
        return `${month} ${date.getFullYear()}`;
    },
    getCurrentDate() {
        const d = new Date();
        const dformat = `${[d.getMonth() + 1,
            d.getDate(),
            d.getFullYear()].join('/')} ${
            [d.getHours(),
                d.getMinutes(),
                d.getSeconds()].join(':')}`;
        let sAMPM = 'AM';
        const iHourCheck = parseInt(d.getHours(), 10);
        if (iHourCheck > 12) {
            sAMPM = 'PM';
        }
        return `${dformat} ${sAMPM}`;
    },
};
